import {setLoading, useMaterialUIController} from "../../Context/mui";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDTableCell from "../../Components/MDTable/MDTableCell";
import {
    Autocomplete,
    ButtonBase,
    Grid,
    Slide, Tab,
    TableBody,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow, Tabs, TextField, useTheme
} from "@mui/material";
import {Table} from "reactstrap";
import MDBox from "../../Components/MDBox";
import Paper from "@mui/material/Paper";
import MDTableRow from "../../Components/MDTable/MDTableRow";
import React, {forwardRef, useEffect, useRef, useState} from "react";
import {MessageModel} from "../../Api/Model/MessageModel";
import Cookies from "js-cookie";
import {v4 as uuid} from "uuid"
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {ReactComponent as DeleteIcon} from '../../Asset/images/icons/deleteicon.svg'
import {ReactComponent as Moshahede} from '../../Asset/images/icons/lets-icons_view.svg'
import MDTypography from "../../Components/MDTypography";
import MDInput from "../../Components/MDInput";
import MDDate from "../../Components/MDDate";
import MDButton from "../../Components/MDButton";
import {ErrorToaast, InfoToaast} from "../../utils/toast/Toast";
import MDSelect from "../../Components/MDSelect";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import {CurrentUser} from "../../utils/Hooks/currentUser";
import {UserModel} from "../../Api/Model/UserModel";
import AddAlertIcon from '@mui/icons-material/AddAlert';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import {Info} from "@mui/icons-material";
import RateReviewIcon from '@mui/icons-material/RateReview';
import {NoskheModel} from "../../Api/Model/NoskheModel";
import {AttachmentsModel} from "../../Api/Model/AttachmentsModel";
import {resolve} from "chart.js/helpers";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
    >
        {value === index && (
            <MDBox sx={{p: 3}}>
                {children}
            </MDBox>
        )}
    </div>
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function defaultLabelDisplayedRows({from, to, count}) {
    return `${from}–${to} از ${
        count !== -1 ? count : `بیشتر از ${to}`
    }`;
}

const initalSearchParams = {
    title: "",
    kind: "",
    file: "",
};
export default function Instructional() {
    const theme = useTheme();
    const [searchParams, setSearchParams] = useState(initalSearchParams);
    const fileRef = useRef(null);
    const [value, setValue] = React.useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [counter, setCounter] = useState(0)
    const [controller, dispatch] = useMaterialUIController();
    const {loading} = controller;
    let Api = new AttachmentsModel(Cookies.get("cst") ?? "");
    const [rows, setRows] = useState({
        content: [],
        pageSize: 0,
        totalPages: 0,
    });
    useEffect(() => {
        setLoading(dispatch, true);
        Api
            .GetAttachments(value, pageNumber, pageSize)
            .then((r) => {
                 setRows(r.data.data);
            })
            .catch
            (r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });


    }, [pageNumber, pageSize, counter]);
    const handleChange = (event, newValue) => {
        setValue(newValue);
        setCounter(p => p + 1);
    };
    const handleChangePage = (event, newPage) => {
        event.preventDefault();

        setPageNumber(newPage + 1);
    };
    const handleChangeRowsPerPage = (
        event
    ) => {
        event.preventDefault();

        setPageSize(+event.target.value);
        setPageNumber(1);
    };

    function HandleDeleteAttachment(id) {
        Api
            .DeleteAttachment(id)
            .then((r) => {
                setCounter(p => p + 1);
                setLoading(dispatch, false)
                InfoToaast("با موفقیت حذف شد")

            })
            .catch
            (r => {
                if (r?.status == 404) {
                    setLoading(dispatch, false)

                    return
                }
                 ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })
            .finally(() => {
                setLoading(dispatch, false);
            });
    }


    function handleSendFile() {
        if (searchParams.title === "" || searchParams.kind === "" || searchParams.file === "") {
            ErrorToaast("لطفا فیلد ها را پر کنید")
            return
        }
        let formData = new FormData();
        formData.append("Title", searchParams.title);
        formData.append("AttachType", searchParams.kind);
        formData.append("File", fileRef?.current?.files[0]);

        setLoading(dispatch, true);
        Api
            .UploadFile(formData)
            .then((r) => {
                InfoToaast("فایل با موفقیت ارسال شد")
                setSearchParams(initalSearchParams)
                setCounter(p => p + 1);
                setLoading(dispatch, false);
            }).catch(() => {
            ErrorToaast("ارسال فایل با مشکل مواجه شد")
            setLoading(dispatch, false);
        })
    }


    return (
        <DashboardLayout>

            <DashboardNavbar name={"مطالب آموزشی"}>
                مطالب آموزشی
            </DashboardNavbar>
            {(CurrentUser()?.Role === "Pezeshk"||CurrentUser()?.Role === "Admin") &&

                <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
                    <MDTypography fontSize={14}>افزودن فایل آموزشی</MDTypography>
                    <Grid
                        container
                        mb={2}
                        // onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    >
                        <Grid item container xs={12} md={6} lg={6} alignItems="center">
                            <Grid item xs={2} textAlign="center">
                                <MDTypography fontSize={14}>عنوان</MDTypography>
                            </Grid>
                            <Grid item xs={8} my={1}>
                                <MDInput
                                    size={"small"}
                                    name="Name"
                                    label={"عنوان"}
                                    fullWidth
                                    onChange={(e) =>
                                        setSearchParams((p) => ({
                                            ...p,
                                            title: e.target.value,
                                        }))
                                    }
                                    value={searchParams.title}
                                    focused
                                    autoComplete="off"
                                />
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} md={6} lg={6} alignItems="center">
                            <Grid item xs={2} textAlign="center">
                                <MDTypography fontSize={14}>نوع فایل</MDTypography>
                            </Grid>
                            <Grid item xs={8} my={1}>

                                <MDSelect
                                    id="kind"
                                    name="kind"
                                    onChange={(r) => {
                                        setSearchParams((p) => ({
                                            ...p,
                                            kind: r,
                                        }))
                                    }}

                                    value={searchParams.kind}

                                    disabled={loading}
                                    w={{xs: "100%", md: "100%", lg: "100%",}}
                                    label={"نوع فایل"}>
                                    <option value={0}>ویدیو</option>
                                    <option value={1}>PDF</option>
                                    <option value={2}>سایر</option>
                                </MDSelect>


                            </Grid>
                        </Grid>
                        <Grid item container xs={12} md={6} lg={6} alignItems="center">
                            <Grid item xs={2} textAlign="center">
                                <MDTypography fontSize={14}>فایل</MDTypography>
                            </Grid>
                            <Grid item xs={8} my={1}>

                                <MDInput
                                    size={"small"}
                                    name="Name"
                                    label={"فایل"}
                                    fullWidth
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        event.preventDefault();
                                        fileRef.current && fileRef.current.click();
                                    }}
                                    onChange={(e) => {
                                    }}
                                    value={fileRef?.current?.files[0]?.name || ""}
                                    autoComplete="off"
                                />
                                <input
                                    hidden={true}
                                    type={"file"}
                                    ref={fileRef}
                                    onChange={(e) => {
                                        setSearchParams((p) => ({
                                            ...p,
                                            file: e.target.files[0] || "",
                                        }));
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid item container xs={12} md={6} lg={6} alignItems="center">
                            <MDButton variant="text" color="info" onClick={() => {
                                handleSendFile()
                            }}>
                                افزودن
                            </MDButton>
                            <MDButton
                                variant="text"
                                color="secondary"
                                onClick={() => {
                                    setSearchParams({kind: "", file: "", title: ""});
                                }}
                            >
                                انصراف
                            </MDButton>
                        </Grid>
                    </Grid>
                </MDBox>
            }
            <MDBox py={3} bgColor={"#e8e8e8"} p={2} mb={2} borderRadius={20}>
                <Tabs
                    textColor="primary"
                    indicatorColor="primary"
                    value={value}
                    onChange={handleChange}
                    centered
                >
                    <Tab label="ویدیو های آموزشی" {...a11yProps(0)}/>
                    <Tab label="PDF های آموزشی" {...a11yProps(1)}/>
                    <Tab label="فایل های دیگر" {...a11yProps(2)}/>
                </Tabs>
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Grid container spacing={2}>
                        {rows?.content?.map(video => (
                            <Grid container direction={"column"} item xs={12} sm={6} key={video.id}>
                                <Grid container item alignItems={"center"} justifyContent={"space-between"}
                                      sx={{background: "white", p: 1, borderRadius: "10px 10px 0 0"}}>
                                    <Grid item>
                                        <MDTypography sx={{lineBreak: "anywhere"}}>
                                            {video?.title}
                                        </MDTypography>
                                    </Grid>
                                    <Grid item>
                                        <MDButton onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                                  variant={"text"} color={"warning"}>
                                            دانلود
                                        </MDButton>
                                        {(CurrentUser()?.Role === "Pezeshk"||CurrentUser()?.Role === "Admin") &&
                                            <MDButton size={"large"}
                                                      onClick={() => HandleDeleteAttachment(video?.id)}
                                                      variant={"text"} color={"error"}>
                                                حذف
                                            </MDButton>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid item flex={1} minHeight={100}>
                                    <video width="100%" height="100%" controls preload="auto" controlsList="nodownload">
                                        <source src={Api.DownloadFile(video?.id)}
                                                type="video/mp4"/>
                                        مرورگر شما ویدیو ساپورت نمیکند
                                    </video>
                                </Grid>
                            </Grid>
                        ))}
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Grid container spacing={2}>
                        {rows?.content?.map(video => (
                            <Grid container direction={"column"} item xs={12} sm={12} key={video.id}>
                                <Grid container item alignItems={"center"}
                                      sx={{background: "white", p: 1, borderRadius: "10px "}}>
                                    <Grid item px={2}>
                                        <img height={50} width={50} src={require("../../Asset/images/pdf.png")}/>
                                    </Grid>
                                    <Grid item flex={1}>
                                        <MDTypography sx={{lineBreak: "anywhere"}}>
                                            {video?.title} ({video?.fileName})
                                        </MDTypography>
                                    </Grid>
                                    <Grid item>
                                        <MDButton size={"large"}
                                                  onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                                  variant={"text"} color={"warning"}>
                                            دانلود
                                        </MDButton>
                                        {(CurrentUser()?.Role === "Pezeshk"||CurrentUser()?.Role === "Admin") &&
                                            <MDButton size={"large"}
                                                      onClick={() => HandleDeleteAttachment(video?.id)}
                                                      variant={"text"} color={"error"}>
                                                حذف
                                            </MDButton>
                                        }
                                    </Grid>
                                </Grid>

                            </Grid>
                        ))}
                    </Grid>
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <Grid container spacing={2}>
                        {rows?.content?.map(video => (
                            <Grid container direction={"column"} item xs={12} sm={12} key={video.id}>
                                <Grid container item alignItems={"center"}
                                      sx={{background: "white", p: 1, borderRadius: "10px "}}>
                                    <Grid item px={2}>
                                        <img height={50} width={50} src={require("../../Asset/images/attachment.png")}/>
                                    </Grid>
                                    <Grid item flex={1}>
                                        <MDTypography sx={{lineBreak: "anywhere"}}>
                                            {video?.title} ({video?.fileName})
                                        </MDTypography>
                                    </Grid>
                                    <Grid item>
                                        <MDButton size={"large"}
                                                  onClick={() => window.open(Api.DownloadFile(video?.id), "_blank")}
                                                  variant={"text"} color={"warning"}>
                                            دانلود
                                        </MDButton>
                                        {(CurrentUser()?.Role === "Pezeshk"||CurrentUser()?.Role === "Admin") &&
                                            <MDButton size={"large"}
                                                      onClick={() => HandleDeleteAttachment(video?.id)}
                                                      variant={"text"} color={"error"}>
                                                حذف
                                            </MDButton>
                                        }
                                    </Grid>
                                </Grid>

                            </Grid>
                        ))}
                    </Grid>
                </TabPanel>
                {rows?.content.length > 0 && (
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.totalPages}
                        rowsPerPage={pageSize}
                        page={pageNumber - 1}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        labelDisplayedRows={defaultLabelDisplayedRows}
                        labelRowsPerPage={<>تعداد در هر صفحه</>}
                    />
                )}
            </MDBox>
        </DashboardLayout>
    )
}